export const STARTS_WITH_DOUBLE_DOT = /^\.\./;
export const DOUBLE_DOT_ERROR = `Cannot start with '..'`;
export const MAX_TEXT_FIELD_WIDTH = 500;
export const MAX_FORM_WIDTH = 800;
export const MAX_TEXT_FIELD_CHAR_LENGTH = 256;

/**
 * Attributes that signal "do not autofill" to the major password managers.
 * Applied globally via `slotProps.htmlInput` defaults on `MuiTextField` and
 * `inputProps` on `MuiInputBase` in the theme.
 *
 * No single attribute works everywhere — `autoComplete="off"` is widely ignored
 * by password managers on purpose, so we stack the vendor-specific opt-outs.
 */
export const ignorePasswordManagers = {
  autoComplete: 'off',
  'data-lpignore': 'true',
  'data-1p-ignore': 'true',
  'data-bwignore': 'true',
  'data-form-type': 'other'
};
